import { createGeneralImageProvider } from '../general-provider';
import { openaiConfigs } from './configs/openai';

/**
 * Dimensio（jimeng.dimensio.cn）图片提供商
 *
 * - 文生图：POST /v1/images/generations
 * - 参考图：POST /v1/images/compositions
 * - 图片同步返回结果，无需轮询
 *
 * 成功响应：{ created, data: [{ url }] }
 * 错误响应：{ code, message, data: null }（code 为负数）
 */
const image = createGeneralImageProvider({
    providerName: 'DIMENSIO',
    baseUrlEnv: 'DIMENSIO_BASE_URL',
    apiKeyEnv: 'DIMENSIO_API_KEY',
    debugEnv: 'DIMENSIO_DEBUG',
    statusMapping: {
        // 同步响应无状态字段：success / failed 传空数组，
        // 按 imageUrlPath 是否取到结果判断成功，按 message 字段提取错误
        taskIdPath: 'task_id',
        statePath: 'status',
        success: [],
        failed: [],
        processing: [],
        imageUrlPath: 'data',
        errorPath: 'message',
        createErrorPath: 'message',
    },
    models: {
        ...openaiConfigs,
    },
});

export const dimensio = { image };
